var actions = {
  updateVerticalNavMenuWidth: function updateVerticalNavMenuWidth(_ref, width) {
    var commit = _ref.commit;
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },
  arrangeStarredPagesLimited: function arrangeStarredPagesLimited(_ref2, list) {
    var commit = _ref2.commit;
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore: function arrangeStarredPagesMore(_ref3, list) {
    var commit = _ref3.commit;
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },
  toggleContentOverlay: function toggleContentOverlay(_ref4) {
    var commit = _ref4.commit;
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme: function updateTheme(_ref5, val) {
    var commit = _ref5.commit;
    commit("UPDATE_THEME", val);
  },
  updateUserInfo: function updateUserInfo(_ref6, payload) {
    var commit = _ref6.commit;
    commit("UPDATE_USER_INFO", payload);
  }
};
export default actions;